export default "__VITE_ASSET__Bo06wsXl__"